import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import CommentPost from 'flarum/forum/components/CommentPost';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
export default function () {
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this.attrs.post;

    if (post.isHidden() || !post.canLike()) return;

    const likes = post.likes();

    let isLiked = app.session.user && likes && likes.some((user) => user === app.session.user);
    // post.save({ isLiked });
    items.add(
      'like',
      <div className="like-btn">
        <Button
          className={'Button Button--link Button-img ' + (isLiked ? 'Button-btn-like-bg' : 'Button-btn-nolike-bg')}
          aria-label="like"
          onclick={(e) => {
            if (this.likeGetState) return;
            isLiked = !isLiked;
            this.likeGetState = true;
            post.save({ isLiked }).then(() => {
              this.likeGetState = false;
              app.discussions.refresh();

              // We've saved the fact that we do or don't like the post, but in order
              // to provide instantaneous feedback to the user, we'll need to add or
              // remove the like from the relationship data manually.
              const data = post.data.relationships.likes.data;
              data.some((like, i) => {
                if (like.id === app.session.user.id()) {
                  data.splice(i, 1);
                  return true;
                }
              });

              if (isLiked) {
                data.unshift({ type: 'users', id: app.session.user.id() });
              }
              e.srcElement.className = 'Button Button--link Button-img ' + (isLiked ? 'Button-btn-like-bg' : 'Button-btn-nolike-bg');
            });

          }}
        >
          {/* {app.translator.trans(isLiked ? 'flarum-likes.forum.post.unlike_link' : 'flarum-likes.forum.post.like_link')} */}
        </Button>
        {abbreviateNumber(Number(post.likesCount()))}
      </div>
    );
  });
}
